import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, PenLine } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../../ui/dialog';
import { haccpApi, erroreHaccp } from '../../haccpApi';
import { DocumentoFirme } from './DocumentoFirme';
import { FirmaSpazio } from './FirmaSpazio';
import { FirmaTuttiAttuatore } from './FirmaTuttiAttuatore';
import { useBlob } from './PaginaFirma';

const MiaFirma = ({ dati, aperto, onCambiato }) => {
  const mia = dati.mia_firma;
  const url = useBlob(aperto && mia ? `/documenti/firme/mia?v=${mia.creata_il}` : null);
  const elimina = async () => {
    if (!window.confirm('Eliminare la firma salvata? La prossima volta la ridisegni.')) return;
    try { await haccpApi.del('/documenti/firme/mia'); onCambiato(); } catch (e) { toast.error(erroreHaccp(e, 'Non eliminata')); }
  };
  return (
    <div className="flex items-center gap-2 rounded-xl border border-gray-200 p-2" data-testid="firme-mia">
      {mia ? <>
        {url ? <img src={url} alt="La mia firma" className="h-10 rounded" style={{ background: '#fff' }} /> : <Loader2 className="h-4 w-4 animate-spin" />}
        <span className="text-xs text-gray-600 flex-1">La tua firma salvata: {mia.nome}</span>
        <button onClick={elimina} className="text-xs text-gray-500 underline" data-testid="firme-mia-elimina">Elimina</button>
      </> : <span className="text-xs text-gray-600">La tua firma la disegni la prima volta che firmi, poi resta salvata.</span>}
    </div>
  );
};

// Elenco dei documenti con gli spazi per le firme; soloDoc mostra solo quel documento
export const FirmeDialog = ({ aperto, soloDoc, dati, onClose, onCambiato }) => {
  const [firma, setFirma] = useState(null);
  const esegui = async (fai, ok) => {
    try { await fai(); if (ok) toast.success(ok); onCambiato(); } catch (e) { toast.error(erroreHaccp(e, 'Operazione non riuscita')); }
  };
  const ignora = (d, s, v) => esegui(() => haccpApi.post(`/documenti/firme/${d.id}/spazi/${s.id}/ignora`, { ignorata: v }));
  const ricontrolla = (d) => esegui(() => haccpApi.post('/documenti/firme/verifica', { documento_id: d.id }), 'Ricontrollo il documento');
  const docs = (dati?.documenti || []).filter((d) => (soloDoc ? d.id === soloDoc : d.spazi.length || d.stato === 'errore'));
  const senza = (dati?.documenti || []).filter((d) => !d.spazi.length && d.stato !== 'errore').length;

  return (
    <>
      <Dialog open={aperto && !firma} onOpenChange={(o) => !o && onClose()}>
        <DialogContent className="max-w-lg w-[96vw] max-h-[92vh] overflow-y-auto rounded-2xl" data-testid="firme-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 pr-6"><PenLine className="h-5 w-5 text-sky-700" />Firme dei documenti</DialogTitle>
            <DialogDescription>Dove manca una firma, firma col dito: l'app la mette nello spazio giusto.</DialogDescription>
          </DialogHeader>
          {dati && <MiaFirma dati={dati} aperto={aperto} onCambiato={onCambiato} />}
          {dati?.verifica?.in_corso && <p className="text-xs text-gray-600 flex items-center gap-1.5"><Loader2 className="h-3.5 w-3.5 animate-spin" />Sto ancora leggendo i documenti: {dati.verifica.fatti} di {dati.verifica.totale}</p>}
          {!soloDoc && <FirmaTuttiAttuatore dati={dati} onPrimaFirma={setFirma} onCambiato={onCambiato} />}
          <div className="space-y-2.5">
            {docs.map((d) => <DocumentoFirme key={d.id} d={d} onFirma={(doc, s) => setFirma({ doc, spazio: s })} onIgnora={ignora} onRicontrolla={ricontrolla} />)}
            {!docs.length && !dati?.verifica?.in_corso && <p className="text-sm text-gray-600 text-center" data-testid="firme-nessuna">Nessuno spazio per firme trovato.</p>}
          </div>
          {!soloDoc && senza > 0 && <p className="text-[11px] text-gray-500">{senza} documenti senza spazi per firme trovati: se serve, usa "Aggiungi firma" sul documento.</p>}
        </DialogContent>
      </Dialog>
      <FirmaSpazio aperto={firma} dati={dati} onClose={() => setFirma(null)} onFirmato={onCambiato} />
    </>
  );
};
